import { v4 as uuidv4 } from 'uuid';

export const genId = () => uuidv4();

export default {};



// WEBPACK FOOTER //
// ./src/modules/shared/utils/uuid.js